import { absenceRequestStatus } from 'pages/Tasks/AbsenceRequest/constants'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import getDeleteWorkflowButton from 'redesign/components/templates/task-details-action-buttons/buttons/delete-workflow-button'
import type { ResolveActionButtonsProps } from 'redesign/components/templates/task-details-action-buttons/types'

export const getWorkflowButtons = ({
  canSendReminder,
  t,
  sendEvent,
  refetch,
  setDialogProps,
  handleButtonAction,
  task,
}: ResolveActionButtonsProps): readonly Action[] => {
  const { status } = task

  if (status === absenceRequestStatus.deletionRequested || !canSendReminder) {
    return []
  }

  return [
    getDeleteWorkflowButton({
      t,
      sendEvent,
      refetch,
      setDialogProps,
      handleButtonAction,
      task,
      buttonProps: {
        label: t('absenceRequest.buttons.deleteWorkflow'),
        testId: 'absence-request_delete-workflow',
      },
    }),
  ]
}
